import {useEffect, useId, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {GradeToString} from "../students/list";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {
    CurrencyFormat,
    NumberToPersianLetters,
    StringDigitsConvertToPersian,
    ToxicDigitsFixToEnglish
} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {TimePicker} from "../../../components/timepicker/timepicker";
import {Calendar, DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";

interface studentsInterface {
    id: number, // studentId
    name: string,
    class: string,
    grade: number,
    isSelected: boolean,
}

export const AdminFinanceGroupReminderModal = (props: { active: boolean, closeHandler: any }) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as studentsInterface[]);
    const fetchList = () => {
        setLoaded(false);
        PostJSON(
            Apis.server + '/core/admins/students/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: {
                    id: number,
                    firstname: string,
                    lastname: string,
                    grade: number,
                    className: string,
                    classId: number,
                    national: string,
                    father: string,
                }[] | null
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                let lst = [] as studentsInterface[];
                if (d.list !== null) {
                    d.list.forEach((s, i) => {
                        lst.push({
                            id: s.id,
                            name: s.firstname + " " + s.lastname,
                            grade: s.grade,
                            class: s.classId > 0 ? s.className : 'بدون کلاس',
                            isSelected: false,
                        });
                    });
                }
                setList([...lst]);
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            setErr({
                price: false,
            });
            document.body.classList.add('body-no-scroll');
            setLevel('select');
            fetchList();
            const today = new Date();
            const g2 = GregorianToPersian(today).split('-');
            setRemindDate({
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            });
            setIsReminded(false);
            setPrice('');
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded || level !== 'select')
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.reports--select-employee-buttons3');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            if(typeof b === 'undefined')
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ','');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ','')) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [level, setLevel] = useState('select' as 'select' | 'fill');
    const [remindDate,setRemindDate] = useState<DayValue>(null);
    const [price,setPrice] = useState('');
    const [isReminded,setIsReminded] = useState(false);
    const ids = {
        price:useId(),
    };
    const [err,setErr] = useState({
        price:false,
    });
    const saveChanges = () => {
        const lst = [...list];
        const finalList = [] as number[];
        lst.forEach(e=>{
            if(e.isSelected)
                finalList.push(e.id);
        });
        const _price = price;
        const _isReminded = isReminded;
        const _remindDate = `${remindDate?.year}-${remindDate?.month}-${remindDate?.day}`;
        if(_price === ''){
            setErr({price: true});
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/finance/group/reminder/add',
            {
                data:JSON.stringify(finalList),
                price:_price,
                remindDate:PersianToGregorian(_remindDate),
                isReminded:_isReminded?'1':'0',
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result!=='OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    'یادآوری های جدید افزوده شد.',
                    'باشه',
                    5000,
                );
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e=>{
            if(!e.isSelected)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '') + (level === 'fill' ? ' web-modal-xl':'')} style={loaded ? {top: 20} : {}}>
                <div className="web-modal-header">
                    <div><b>ثبت یادآوری گروهی</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="reports--select-employee">
                        {
                            loaded ?
                                (
                                    level === 'fill' ?
                                        <>
                                            <div className="container">
                                                <div className="add-student row">
                                                    <div className="col-md-6">
                                                        <label htmlFor={ids.price}>مبلغ پیشنهادی:</label>
                                                        <input type="number"
                                                               step={1000}
                                                               min={0}
                                                               id={ids.price}
                                                               value={price}
                                                               className={"form-control" + (err.price ? ' is-invalid' : '')}
                                                               onChange={e => {
                                                                   const t = e.currentTarget.value;
                                                                   setPrice(t);
                                                                   setErr(v => {
                                                                       let x = {...v};
                                                                       x.price = false;
                                                                       return x;
                                                                   })
                                                               }}
                                                        />
                                                        {
                                                            price !== '' ?
                                                                <span style={{
                                                                    display: 'block',
                                                                    margin: '5px 0 0 0',
                                                                    fontWeight: 400,
                                                                    color: '#0a53be'
                                                                }}>{NumberToPersianLetters(parseInt(price)) + " تومان"}</span> : null
                                                        }
                                                        <div
                                                            className={"invalid-feedback " + (err.price ? 'd-block' : 'd-none')}>
                                                            لطفا یک مبلغ وارد کنید.
                                                        </div>
                                                        <div style={{height: 20}}/>
                                                        <label>وضعیت یادآوری:</label>
                                                        <button
                                                            className={"techaran-radio-box" + (isReminded ? ' active' : '')}
                                                            onClick={() => setIsReminded(true)}>
                                                            <div><i/></div>
                                                            <span>یادآوری شده</span>
                                                        </button>
                                                        <button
                                                            className={"techaran-radio-box" + (!isReminded ? ' active' : '')}
                                                            onClick={() => setIsReminded(false)}>
                                                            <div><i/></div>
                                                            <span>در انتظار</span>
                                                        </button>
                                                        <div style={{height: 20}}/>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>تاریخ یادآوری:</label>
                                                        <Calendar
                                                            value={remindDate}
                                                            onChange={e => setRemindDate(e)}
                                                            shouldHighlightWeekends
                                                            colorPrimary='#0a53be'
                                                            locale='fa'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end align-items-center"
                                                     style={{gap: 20, marginTop: 30}}>
                                                    <button className="cancel-button" onClick={props.closeHandler}>
                                                        <b>انصراف</b>
                                                    </button>
                                                    <button className="btn-pay" onClick={saveChanges}>
                                                        <b>ذخیره تغییرات</b>
                                                    </button>
                                                </div>
                                            </div>
                                        </> :
                                        <>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label>انتخاب دانش‌آموزان</label>
                                                <button className="btn-pay" onClick={() => {
                                                    const lst = [...list];
                                                    if (lst.findIndex((e) => e.isSelected) < 0) {
                                                        ShowSnackbar('لطفا حداقل یک دانش‌آموز را انتخاب کنید.', 'باشه', 5000);
                                                        return;
                                                    }
                                                    setLevel('fill');
                                                }}>
                                                    <b>مرحله بعدی</b>
                                                </button>
                                            </div>
                                            <div className="pick-device-search">
                                                <button><SearchIcon/></button>
                                                <input type="text"
                                                       value={search}
                                                       onChange={e => setSearch(e.currentTarget.value)}
                                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                                       className="f-roboto"
                                                       placeholder={"جستجو براساس نام یا کلاس..."}
                                                />
                                            </div>
                                            {
                                                search.trim() === '' && list.length > 0 ?
                                                    <>
                                                        <hr/>
                                                        <button
                                                            className={"techaran-checkbox" + (isAllChecked() ? ' active' : '')}
                                                            onClick={() => {
                                                                const isChecked = isAllChecked();
                                                                if (isChecked)
                                                                    setList(v => {
                                                                        let x = [...v];
                                                                        x.forEach(r => {
                                                                            r.isSelected = false;
                                                                        });
                                                                        return x;
                                                                    });
                                                                else
                                                                    setList(v => {
                                                                        let x = [...v];
                                                                        x.forEach(r => {
                                                                            r.isSelected = true;
                                                                        });
                                                                        return x;
                                                                    });
                                                            }}>
                                                        <i><CheckIcon/></i>
                                                            <span>انتخاب همه</span>
                                                        </button>
                                                        <hr/>
                                                    </> : null
                                            }
                                            <div className="reports--select-employee-buttons3">
                                                {
                                                    list.map((e, i) =>
                                                            <button key={"KJds83jns8932d1" + i}
                                                                    className={"techaran-checkbox" + (e.isSelected ? ' active' : '')}
                                                                    onClick={() => setList(v => {
                                                                        let x = [...v];
                                                                        const id = x.findIndex(r => r.id === e.id);
                                                                        x[id].isSelected = !x[id].isSelected;
                                                                        return x;
                                                                    })}>
                                                                <i>
                                                                    <CheckIcon/>
                                                                </i>
                                                                <span>
                                            {e.name.replaceAll('ي','ی')}
                                                                    <em>{(e.class === '' ? 'بدون کلاس - ' : `${e.class} - `) + GradeToString(e.grade)}</em>
                                        </span>
                                                            </button>
                                                    )
                                                }
                                            </div>
                                        </>
                                ) :
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{padding: '70px 0'}}>
                                    <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};